module.exports = __webpack_public_path__ + "img/hp_2.6683ebda.png";